import {
  DocumentWorkOrderStateTypes,
  DocumentWorkOrderActionTypes,
} from "./DocumentWorkOrder.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: DocumentWorkOrderStateTypes = {
  fetchAll: resetApiCallState([]),
};

const DocumentWorkOrderReducer = (
  state: DocumentWorkOrderStateTypes = INITIAL_STATE,
  action: any
): DocumentWorkOrderStateTypes => {
  switch (action.type) {
    case DocumentWorkOrderActionTypes.FETCH_ALL_DOCUMENT_WORK_ORDER:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case DocumentWorkOrderActionTypes.FETCH_ALL_DOCUMENT_WORK_ORDER_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case DocumentWorkOrderActionTypes.FETCH_ALL_DOCUMENT_WORK_ORDER_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case DocumentWorkOrderActionTypes.FETCH_ALL_DOCUMENT_WORK_ORDER_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default DocumentWorkOrderReducer;
